<template>
  <div id="app">

    <navigation-header></navigation-header>

<!--      <div class="row">-->
<!--        <div class="col-md-2 col-sm-1">-->
<!--        </div>-->
<!--        <div class="col-md-8 col-sm-10">-->
          <router-view/>
<!--        </div>-->
<!--        <div class="col-md-2 col-sm-1">-->
<!--        </div>-->
<!--      </div>-->

    </div>

</template>

<script>
  import NavigationHeader from './components/NavigationHeader.vue';
  import {signOut} from "./utils/auth";
  import {mapGetters} from "vuex";

  export default {
    components: {
      'navigation-header' : NavigationHeader
    },
    created () {
      window.addEventListener('beforeunload', this.closed_sign_out)
    },
    computed: {
      ...mapGetters({
        dont_sign_out: 'admin/dont_sign_out',
      }),
    },
    methods: {
      closed_sign_out() {
        if(this.dont_sign_out === 0) // direct opening of page. Opened via param customer id new tab sets it to 1
        {
          signOut();
        }
      }
    },
  }
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
  }
</style>
